import { useState, useEffect, useContext } from "react";
import axios from "axios";
import Preloader from "../../../shared/PreLoaders";
import { Authorization } from "../../../Context/Authorization";
import { AuthContext } from "../../../Context/AuthContext";
import { toast } from "react-toastify";
import { logActivity } from "../../../utils/LogActivity";

const inputStyle = {
  width: "100%", padding: "9px 12px", border: "1.5px solid #E2E8F0",
  borderRadius: 8, fontSize: 13, color: "#1A202C", background: "#fff",
  outline: "none", transition: "border-color 0.2s",
};
const labelStyle = { fontSize: 12, fontWeight: 600, color: "#2D3748", marginBottom: 6, display: "block" };

const Field = ({ label, children }) => (
  <div style={{ marginBottom: 14 }}>
    <label style={labelStyle}>{label}</label>
    {children}
  </div>
);
const SInput = (props) => (
  <input style={inputStyle} onFocus={(e) => e.target.style.borderColor = "#4CAF50"} onBlur={(e) => e.target.style.borderColor = "#E2E8F0"} {...props} />
);
const SSelect = ({ children, ...props }) => (
  <select style={{ ...inputStyle, cursor: "pointer" }} onFocus={(e) => e.target.style.borderColor = "#4CAF50"} onBlur={(e) => e.target.style.borderColor = "#E2E8F0"} {...props}>{children}</select>
);

const AuditVfc = () => {
  const { userId, selectedJfmcType } = useContext(AuthContext);
  const [auditorName, setAuditorName] = useState("");
  const [balanceDuringAudit, setBalanceDuringAudit] = useState("");
  const [auditDate, setAuditDate] = useState("");
  const [uploadDocument, setUploadDocument] = useState(null);
  const [vfcId, setVfcId] = useState("");
  const [vfcs, setVfcs] = useState([]);
  const [previousReports, setPreviousReports] = useState([]);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingAuditId, setEditingAuditId] = useState(null);
  const [vfcAudits, setVfcAudits] = useState([]);
  const Api = process.env.REACT_APP_API;
  const MAX_FILE_SIZE = 1 * 1024 * 1024;

  useEffect(() => {
    if (selectedJfmcType) {
      setVfcId("");
      setPreviousReports([]);
      fetchVfc(selectedJfmcType._id);
      handleFetchPreviousReports(); // ADD THIS
    }
  }, [selectedJfmcType]);

  const fetchVfc = async (jfmcTypeId) => {
    try {
      setLoading(true);
      const config = Authorization();
      const res = await axios.post(`${Api}/api/vfcs/names`, { jfmcTypeId }, config);

      const prepared = res.data.vfcs.map((vfc) => ({
        ...vfc,
        auditorName: "",
        balanceDuringAudit: "",
        auditDate: "",
        uploadDocument: null,
      }));

      setVfcs(res.data.vfcs);
      setVfcAudits(prepared);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  const handleFetchPreviousReports = async () => {
    try {
      setLoading(true);
      const config = Authorization();

      const res = await axios.post(
        `${Api}/api/audits/previous`,
        {}, // ✅ NO vfcId
        config
      );

      setPreviousReports(res.data);
    } catch (err) {
      console.error(err);
      setPreviousReports([]);
    } finally {
      setLoading(false);
    }
  };
  const handleRowChange = (index, field, value) => {
    const updated = [...vfcAudits];
    updated[index][field] = value;
    setVfcAudits(updated);
  };

  const handleFileChangeRow = (index, file) => {
    if (!file) return;

    if (file.size > MAX_FILE_SIZE) {
      setError("File size must be ≤ 1 MB.");
      return;
    }

    const updated = [...vfcAudits];
    updated[index].uploadDocument = file;
    setVfcAudits(updated);
  };
  const handleEdit = (report) => {
    const index = vfcAudits.findIndex(
      (v) => v._id === report.vfcId._id
    );

    if (index === -1) return;

    const updated = [...vfcAudits];

    updated[index] = {
      ...updated[index],
      auditId: report._id, // ✅ IMPORTANT
      auditorName: report.auditorName,
      balanceDuringAudit: report.balanceDuringAudit,
      auditDate: report.auditDate.split("T")[0],
      uploadDocument: null
    };

    setVfcAudits(updated);

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const resetForm = () => { setIsEditMode(false); setEditingAuditId(null); setAuditorName(""); setBalanceDuringAudit(""); setAuditDate(""); setUploadDocument(null); };

  const handleSubmitAll = async () => {
    try {
      setLoading(true);
      const config = Authorization();

      const validRows = vfcAudits.filter(
        (v) => v.auditDate && v.auditorName
      );

      if (validRows.length === 0) {
        setError("Please fill at least one audit");
        return;
      }

      const promises = validRows.map(async (v) => {
        const fd = new FormData();

        fd.append("vfcId", v._id);
        fd.append("auditorName", v.auditorName);
        fd.append("balanceDuringAudit", v.balanceDuringAudit);
        fd.append("auditDate", v.auditDate);

        if (v.uploadDocument) {
          fd.append("uploadDocument", v.uploadDocument);
        }

        // ✅ CHECK EDIT OR CREATE
        if (v.auditId) {
          return fetch(`${Api}/api/audits/${v.auditId}`, {
            method: "PUT", // ✅ UPDATE
            headers: { ...config.headers },
            body: fd,
          });
        } else {
          return fetch(`${Api}/api/audits`, {
            method: "POST", // ✅ CREATE
            headers: { ...config.headers },
            body: fd,
          });
        }
      });

      await Promise.all(promises);

      setSuccessMessage("All audits submitted successfully");
      toast.success("Range added successfully");
      await logActivity(userId, "New Range Added", "Add Range Page", Api);
      resetAllRows()
      handleFetchPreviousReports();

      setTimeout(() => setSuccessMessage(null), 3000);
    } catch (err) {
      console.error(err);
      setError("Failed to submit audits");
    } finally {
      setLoading(false);
    }
  };
  const handleDelete = async (auditId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this audit record?"
    );

    if (!confirmDelete) return;

    try {
      setLoading(true);

      const config = Authorization();

      await axios.delete(
        `${Api}/api/audits/${auditId}`,
        config
      );

      toast.success("Audit deleted successfully");

      // remove from UI instantly
      setPreviousReports((prev) =>
        prev.filter((audit) => audit._id !== auditId)
      );

      // reset edit state if deleted item was being edited
      setEditingAuditId(null);
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete audit");
    } finally {
      setLoading(false);
    }
  };
  const resetAllRows = () => {
    const resetData = vfcs.map((vfc) => ({
      ...vfc,
      auditId: null, // ✅ RESET
      auditorName: "",
      balanceDuringAudit: "",
      auditDate: "",
      uploadDocument: null,
    }));

    setVfcAudits(resetData);
  };

  /* ════════════════════════════════════════════
     RENDER
  ════════════════════════════════════════════ */
  return (
    <div>
      {loading && <Preloader loading={loading} />}

      {/* ── Page Header ── */}
      <div style={{ marginBottom: 20 }}>
        <h4 style={{ margin: 0, fontWeight: 700, color: "#1A202C", fontSize: 18 }}>Audit Reports</h4>
        <div style={{ fontSize: 12, color: "#718096", marginTop: 3 }}>
          <span style={{ color: "#A0AEC0" }}>JFMC</span>
          <span style={{ margin: "0 6px", color: "#CBD5E0" }}>›</span>
          <span style={{ color: "#2E7D32", fontWeight: 600 }}>Audit Reports</span>
        </div>
      </div>

      {/* ── Alerts ── */}
      {error && (
        <div style={{ marginBottom: 14, padding: "10px 14px", background: "#FFEBEE", border: "1px solid #FFCDD2", borderRadius: 8, fontSize: 13, color: "#C62828", display: "flex", alignItems: "center", gap: 8 }}>
          <i className="mdi mdi-alert-circle-outline" /> {error}
        </div>
      )}
      {successMessage && (
        <div style={{ marginBottom: 14, padding: "10px 14px", background: "#E8F5E9", border: "1px solid #C8E6C9", borderRadius: 8, fontSize: 13, color: "#2E7D32", display: "flex", alignItems: "center", gap: 8 }}>
          <i className="mdi mdi-check-circle-outline" /> {successMessage}
        </div>
      )}

      {/* ── No JFMC type selected ── */}
      {!selectedJfmcType ? (
        <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #FED7D7", padding: "48px 24px", textAlign: "center" }}>
          <div style={{ width: 60, height: 60, background: "#FFF5F5", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px" }}>
            <i className="mdi mdi-tag-outline" style={{ fontSize: 28, color: "#E53E3E" }} />
          </div>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#2D3748", marginBottom: 6 }}>JFMC Type not selected</div>
          <div style={{ fontSize: 12, color: "#A0AEC0" }}>Use the <strong>JFMC Type</strong> selector in the top navigation bar</div>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>

          {/* ── Form Card ── */}
          <div style={{ flex: "0 0 42%", background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 20px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
              <span style={{ width: 36, height: 36, background: "rgba(255,255,255,0.15)", borderRadius: 9, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 18 }}>
                <i className="mdi mdi-calendar-check-outline" />
              </span>
              <div style={{ fontSize: 14, fontWeight: 700, color: "#fff" }}>{editingAuditId ? "Edit Audit" : "Create Audit"}</div>
            </div>

            <div style={{ padding: 20 }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                <thead>
                  <tr style={{
                    borderBottom: "1px solid #EDF2F7"
                  }}>
                    {["#", "VFC Name", "Auditor", "Date", "Balance", "File"].map((h) => (
                      <th key={h} style={{
                        padding: "10px",
                        borderBottom: "1px solid #E2E8F0",
                        background: "#F7FAFC",
                        fontSize: 12
                      }}>
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {vfcAudits.map((v, i) => (
                    <tr key={v._id} style={{
                      borderBottom: "1px solid #EDF2F7"
                    }}>
                      <td style={{ padding: 8, }}>{i + 1}</td>
                      <td style={{ padding: 8, fontWeight: 600 }}>{v.vfcName}</td>

                      <td style={{ padding: 8 }}>
                        <SInput
                          value={v.auditorName}
                          onChange={(e) =>
                            handleRowChange(i, "auditorName", e.target.value)
                          }
                          style={inputStyle}
                        />
                      </td>

                      <td style={{ padding: 8 }}>
                        <SInput
                          type="date"
                          value={v.auditDate}
                          onChange={(e) =>
                            handleRowChange(i, "auditDate", e.target.value)
                          }
                          style={inputStyle}
                        />
                      </td>

                      <td style={{ padding: 8 }}>
                        <SInput
                          type="number"
                          min={0}
                          value={v.balanceDuringAudit}
                          onChange={(e) =>
                            handleRowChange(i, "balanceDuringAudit", e.target.value)
                          }
                          style={inputStyle}
                        />
                      </td>

                      <td style={{ padding: 8 }}>
                        <input
                          type="file"
                          onChange={(e) =>
                            handleFileChangeRow(i, e.target.files[0])
                          }
                          style={inputStyle}
                        />
                      </td>

                      <td>
                        {v.auditId && (
                          <span style={{ color: "#E65100", fontSize: 11 }}>
                            Editing...
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button onClick={handleSubmitAll} style={{
                marginTop: 15,
                padding: "10px 20px",
                background: "linear-gradient(135deg,#1B5E20,#2E7D32)",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                fontWeight: 600,
                cursor: "pointer"
              }}>Submit All</button>
            </div>
          </div>

          {/* ── Previous Reports Card ── */}
          <div style={{ flex: 1, background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
              <span style={{ width: 30, height: 30, background: "rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 15 }}>
                <i className="mdi mdi-history" />
              </span>
              <span style={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>Previous Audit Reports</span>
              <span style={{ marginLeft: "auto", background: "rgba(255,255,255,0.2)", color: "#fff", fontSize: 11, fontWeight: 700, padding: "2px 10px", borderRadius: 50 }}>{previousReports.length}</span>
            </div>
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                <thead>
                  <tr>
                    {["#", "JFMC Name", "Auditor Name", "Audit Date", "Balance on Audit", "Action"].map((h) => (
                      <th key={h} style={{ padding: "11px 14px", textAlign: "left", fontWeight: 600, fontSize: 12, color: "#4A5568", borderBottom: "1px solid #EDF2F7", background: "#F7FAFC", whiteSpace: "nowrap" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {previousReports.length === 0 ? (
                    <tr><td colSpan={6} style={{ padding: "32px", textAlign: "center", color: "#A0AEC0", fontSize: 13 }}>No audit reports yet</td></tr>
                  ) : (
                    previousReports.map((r, i) => (
                      <tr key={i} style={{ borderBottom: "1px solid #EDF2F7" }}
                        onMouseEnter={(e) => e.currentTarget.style.background = "#F7FAFC"}
                        onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>
                        <td style={{ padding: "10px 14px", color: "#718096" }}>{i + 1}</td>
                        <td style={{ padding: "10px 14px", color: "#1A202C", fontWeight: 600 }}>
                          {r.vfcId?.vfcName || "—"}
                        </td>                        <td style={{ padding: "10px 14px", color: "#4A5568" }}>{r.auditorName}</td>
                        <td style={{ padding: "10px 14px", color: "#4A5568", whiteSpace: "nowrap" }}>{new Date(r.auditDate).toLocaleDateString("en-IN")}</td>
                        <td style={{ padding: "10px 14px" }}>
                          <span style={{ background: "#E8F5E9", color: "#2E7D32", fontSize: 11, fontWeight: 700, padding: "3px 8px", borderRadius: 50 }}>₹{r.balanceDuringAudit}</span>
                        </td>
                        <td style={{ padding: "10px 14px" }}>
                          <div style={{ display: "flex", gap: 8 }}>
                            <button
                              onClick={() => handleEdit(r)}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 5,
                                padding: "5px 12px",
                                background: "linear-gradient(135deg,#1B5E20,#2E7D32)",
                                color: "#fff",
                                border: "none",
                                borderRadius: 7,
                                fontSize: 12,
                                fontWeight: 600,
                                cursor: "pointer"
                              }}
                            >
                              <i className="mdi mdi-pencil" style={{ fontSize: 13 }} />
                              Edit
                            </button>

                            <button
                              onClick={() => handleDelete(r._id)}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 5,
                                padding: "5px 12px",
                                background: "linear-gradient(135deg,#C62828,#E53935)",
                                color: "#fff",
                                border: "none",
                                borderRadius: 7,
                                fontSize: 12,
                                fontWeight: 600,
                                cursor: "pointer"
                              }}
                            >
                              <i className="mdi mdi-delete" style={{ fontSize: 13 }} />
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AuditVfc;
